<div class="main-report">
  <div
    class="main-slide-report-toc toc-sidebar"
    [ngClass]="isTocVisible ? 'toc-header-on' : 'toc-header-off'"
  >
    <piqet-angular-table-of-content
      [tocSections]="tocSections"
      [isTocVisible]="isTocVisible"
      (toggleBtn)="toggleToc($event)"
    ></piqet-angular-table-of-content>
  </div>
  <div [ngClass]="isTocVisible ? 'toc-content-on' : 'toc-content-off'">
    <div class="reportSpacing main-slide-report">
      <div>
        <!-- report cover page -->
        <div>
          <!-- Piqet Logo & Organization Logo -->
          <div
            class="logo-div d-flex flex-column flex-md-row justify-content-start justify-content-md-between align-items-start align-items-md-center"
          >
            <div class="m-0 p-0">
              <img [src]="piqetLogo" id="piqetLogo" alt="Piqet logo" />
            </div>
            <div class="m-0 p-0" *ngIf="reportData?.organizationLogo">
              <img
                [src]="reportData?.organizationLogo"
                id="organizationLogo"
                alt="Organization image"
              />
            </div>
          </div>

          <!-- Project name -->
          <div class="main-contant">
            <div class="maintext-heading">
              <span class="purpleProjectName">{{ mainProjectName }}</span>
              {{ remainingProjectName }} -
              <br />
              {{ reportResource.lblDetailedReport }}
            </div>
          </div>
          <!-- Scenario Image List -->
          <div
            class="left-align-padding d-flex flex-wrap gap-2"
            *ngIf="reportData?.scenarioImageList?.length"
          >
            <div *ngFor="let item of reportData?.scenarioImageList" class="w-fit-content">
              <img *ngIf="item?.imageName" [src]="item?.imageName" height="100" width="100" />
            </div>
          </div>
          <!-- Profile Image -->
          <div class="profile-detail-div">
            <div
              class="profile-image-div"
              *ngIf="!!reportData?.profileImage && reportData?.profileImage != ''"
            >
              <img
                [src]="'data:image/jpg;base64,' + reportData?.profileImage"
                alt="Profile image"
              />
            </div>
            <div class="profile-detail">
              <p class="userNameOrorganization">{{ reportData?.username }}</p>
            </div>
          </div>
          <!-- Organization name -->
          <div class="organizatio-name-div">
            <div class="organizatio-name">
              <p class="userNameOrorganization">{{ reportData?.organizationName }}</p>
            </div>
          </div>
          <!-- <div class="bottom-contant">
              <div class="">Generated by</div>
              <div class="">{{reportData?.username}}</div>
              <div class="">{{reportData?.organizationName}}</div>
            </div> -->

          <div class="last-bottom-contant">
            <div class="">PIQET project code: {{ reportData?.projectCode }}</div>
            <div class="">
              Report generated: {{ reportData?.reportGenerateDate | date : 'yyyy-MM-dd HH:mm' }}
            </div>
            <div class="">Software version: PIQET {{ reportData?.softwareVersion }}</div>
          </div>
        </div>
      </div>

      <piqet-angular-toc-list [title]="'Figures'" [indexList]="figureIndexList">
      </piqet-angular-toc-list>

      <piqet-angular-toc-list [title]="'Tables'" [indexList]="tableIndexList">
      </piqet-angular-toc-list>
      <div>
        <!-- Content Page -->
        <div class="reportContent">
          <!-- 3 = project summary id -->
          <div class="project-detail-div page-break">
            <div class="row space" id="projectDetail">
              <div class="headingTitle">Project details</div>
            </div>
            <div class="row table-div">
              <div class="tableHeading">
                <div class="uniqTableSeq content-name-subtitle">
                  Table #1: {{ reportResource.lblSummaryProject }}
                </div>
              </div>
              <div class="table-content">
                <table class="table">
                  <thead>
                    <tr>
                      <td>PIQET project code</td>
                      <td>{{ reportData?.projectCode }}</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Name</td>
                      <td>{{ reportData?.projectName }}</td>
                    </tr>
                    <tr *ngIf="!reportData.isInterpretationRights">
                      <td>Description</td>
                      <td>{{ reportData?.projectDescription }}</td>
                    </tr>
                    <tr>
                      <td>Share with</td>
                      <td>{{ reportData?.shareWith }}</td>
                    </tr>
                    <tr>
                      <td>Status</td>
                      <td>{{ reportData?.status }}</td>
                    </tr>
                    <tr *ngIf="!reportData.isTurnOffCost">
                      <td>Currency</td>
                      <td>{{ reportData?.currency }}</td>
                    </tr>
                    <tr>
                      <td>Default country</td>
                      <td>{{ reportData?.defaultCountry }}</td>
                    </tr>
                    <tr>
                      <td>Other countries</td>
                      <td>{{ reportData?.otherCountries }}</td>
                    </tr>
                    <tr>
                      <td>Basis for comparison</td>
                      <td>{{ reportData?.basisforComparision }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- Table & Table title -->
            <div class="row table-div" *ngIf="reportData?.propackscenarioList.length > 0">
              <div class="tableHeading">
                <div class="uniqTableSeq content-name-subtitle">
                  Table #1 {{ reportResource.lblSummaryScenarios }}
                </div>
              </div>
              <div class="table-content">
                <table class="table">
                  <thead>
                    <tr>
                      <td>Package product system</td>
                      <td>Package</td>
                      <td>Product</td>
                      <td>Product quantity</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let scenario of reportData?.propackscenarioList">
                      <td>{{ scenario?.propackScenarioname }}</td>
                      <td>{{ scenario?.package }}</td>
                      <td>{{ scenario?.productSector }}</td>
                      <td>{{ scenario?.productQuantity }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div *ngIf="reportData.isInterpretationRights">
            <div>
              <div>
                <!-- Goal Section -->
                <div
                  *ngIf="
                    reportData.goalAndScope?.goal && reportData.goalAndScope.goal.trim() !== ''
                  "
                >
                  <div class="row sub-title-class space">
                    <div>
                      <div>Goal and scope</div>
                    </div>
                  </div>
                  <div>
                    <p class="row space contentClass content-text">
                      {{ reportData.goalAndScope.goal }}
                    </p>
                  </div>
                </div>

                <!-- System Boundary Section -->
                <div
                  *ngIf="
                    reportData.goalAndScope?.systemBoundaryJustification &&
                    reportData.goalAndScope.systemBoundaryJustification.trim() !== ''
                  "
                >
                  <div class="row sub-title-class space">
                    <div>
                      <div>System boundary justification</div>
                    </div>
                  </div>
                  <div>
                    <p class="row space contentClass content-text">
                      {{ reportData.goalAndScope.systemBoundaryJustification }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Scenario Comparison -->
          <div>
            <!-- Title -->
            <div>
              <div class="page-break"></div>
              <div class="row space" id="scenarioComparison">
                <div class="headingTitle setFontWeight">Scenario comparison</div>
              </div>
            </div>

            <div
              *ngIf="
                reportData?.propackscenarioList.length > 0 &&
                reportData?.lifeCycleStageContributionImpactItems.length > 0
              "
            >
              <!-- Sub-title -->
              <div class="row sub-title-class">
                <div>
                  <div>At a glance comparison</div>
                </div>
              </div>
              <!-- Description -->
              <div>
                <p class="row space contentClass content-text">
                  The following chart compares the relative impact of selected scenarios on equal
                  weighted indicators.
                </p>
                <p class="row space contentClass content-text">
                  Note: Spider diagram below shows relative impacts of scenarios being compared;
                  closer to the centre, lesser is the environmental impact.
                </p>
              </div>
            </div>
            <piqet-angular-life-cycle-impact-chart
              [SpiderChartItems]="reportData?.spiderChartItems"
              [isFullReport]="true"
            ></piqet-angular-life-cycle-impact-chart>
          </div>

          <!-- packagingMatrics -->
          <div *ngIf="reportData?.additionalItems?.toLowerCase().includes('1')">
            <div *ngIf="reportData.isExport; else other_packagingMatrics">
              <div class="row table-div">
                <div class="page-break"></div>
                <div class="tableHeading">
                  <div class="uniqTableSeq content-name-subtitle">
                    Table #1 {{ reportResource.lblPackingMatrics }}
                  </div>
                </div>
              </div>
              <piqet-angular-packaging-matrics
                [packagingMatrics]="reportData?.packagingMatrics"
              ></piqet-angular-packaging-matrics>
            </div>
            <ng-template #other_packagingMatrics>
              <ng-container>
                <piqet-angular-packaging-matrics
                  [packagingMatrics]="reportData?.packagingMatrics"
                ></piqet-angular-packaging-matrics>
              </ng-container>
            </ng-template>
          </div>

          <ng-container *ngIf="isHideLblMaterialCertification">
            <div class="row table-div">
              <div class="page-break"></div>
              <div class="tableHeading">
                <div class="uniqTableSeq content-name-subtitle">
                  Table #1: {{ reportResource.lblMaterialCertification }}
                </div>
              </div>
            </div>

            <div class="row table-div" id="materialCertification">
              <div class="table-content">
                <table class="table" *ngIf="reportData?.materialCertificateImpact">
                  <thead>
                    <tr>
                      <td [style.width.%]="firstColumnWidth">Criteria</td>
                      <td
                        [style.width.%]="otherColumnWidth"
                        *ngFor="let header of reportData.materialCertificateImpact.components"
                      >
                        {{ header }}
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container
                      *ngFor="let row of reportData.materialCertificateImpact.list; let i = index"
                    >
                      <tr
                        *ngIf="
                          i === 0 ||
                          row.group !== reportData.materialCertificateImpact.list[i - 1]?.group
                        "
                        class="group-row"
                      >
                        <td
                          [attr.colspan]="
                            reportData.materialCertificateImpact.components.length + 1
                          "
                          class="groupTd"
                        >
                          {{ row.group }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{ row.criteria }}</td>
                        <td *ngFor="let val of row.values">{{ val }}</td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>

          <!-- totalImpactchartcontainer -->

          <!-- Section end here -->

          <div class="row space">
            <div class="page-break"></div>
            <div class="headingTitle setFontWeight" id="interpretationResult">
              {{ reportResource.lblInterpretationResults }}
            </div>
          </div>
          <div class="row-table-div">
            <div>
              <div class="row">
                <div class="lblLifeCyclesStages" id="lifeCycleStages">
                  {{ reportResource.lblLifeCyclesStages }}
                </div>
              </div>
            </div>
            <div>
              <p class="row space contentClass content-text">
                {{ reportResource.lblSectionLifeCycleStage }}
              </p>
            </div>

            <div
              *ngFor="
                let indicatorDetail of reportData?.lifeCycleStageContributionImpactItems;
                let i = index
              "
            >
              <div [ngClass]="i == 0 ? '' : 'page-break'"></div>
              <div class="indicatorName">
                <span class="Titalcase">{{ indicatorDetail?.indicatorName }}</span
                >&nbsp; ({{ indicatorDetail?.indicatorUnitName }})
              </div>

              <div class="tableHeadingForLifecycleStage">
                <div class="uniqTableSeq content-name-subtitle">
                  Table #1: {{ indicatorDetail?.indicatorName }}
                  {{ reportResource.lblLifeCycle | lowercase }} -
                  {{ reportData?.functionalUnitName | lowercase }}
                </div>
              </div>
              <div style="margin-bottom: 30px">
                <piqet-angular-life-cycle-stage-chart
                  [isIsoReport]="true"
                  [indicatorDetail]="indicatorDetail?.impactItems"
                ></piqet-angular-life-cycle-stage-chart>
              </div>
              <p class="figureIdClass uniqFigureSeq content-name-subtitle">
                Figure #1: {{ indicatorDetail?.indicatorName }} ({{
                  indicatorDetail?.indicatorUnitName
                }}) comparison {{ reportResource.lblLifeCycle | lowercase }} -
                {{ reportData?.functionalUnitName | lowercase }}
              </p>
            </div>
          </div>

          <!-- need to add figerid -->
          <div class="page-break"></div>
          <div class="row-table-div">
            <div>
              <div class="row">
                <div class="lblLifeCyclesStages" id="lifeCyclePackagingLevel">
                  {{ reportResource.lblPackingLevel }}
                </div>
              </div>
            </div>
            <div
              *ngFor="
                let indicatorDetail of reportData?.packagingLevelContributionImpactItems;
                let i = index
              "
            >
              <div [ngClass]="i == 0 ? '' : 'page-break'"></div>
              <div class="indicatorName">
                <span class="Titalcase">{{ indicatorDetail?.indicatorName }}</span
                >&nbsp; ({{ indicatorDetail?.indicatorUnitName }})
              </div>
              <div class="tableHeadingForLifecycleStage">
                <div class="uniqTableSeq content-name-subtitle">
                  Table #1: {{ indicatorDetail?.indicatorName }}
                  {{ reportResource.lblPackingLevelStage | lowercase }} -
                  {{ reportData?.functionalUnitName | lowercase }}
                </div>
              </div>
              <div style="margin-bottom: 30px">
                <piqet-angular-report-bar-chart
                  [isIsoReport]="true"
                  [impactItems]="indicatorDetail?.impactItems"
                ></piqet-angular-report-bar-chart>
              </div>
              <p class="figureIdClass uniqFigureSeq content-name-subtitle">
                Figure #1: {{ indicatorDetail.indicatorName }} ({{
                  indicatorDetail?.indicatorUnitName
                }}) comparison of {{ reportResource.lblPackingLevelStage | lowercase }} -
                {{ reportData?.functionalUnitName | lowercase }}
              </p>
            </div>
          </div>

          <div class="page-break"></div>
          <div class="row table-div">
            <div>
              <div class="row">
                <div class="lblLifeCyclesStages" id="packagingComponent">
                  {{ reportResource.lblComponents }}
                </div>
              </div>
            </div>
            <div>
              <p class="row space contentClass content-text">
                {{ reportResource.lblSectionLifeCycleStage }}
              </p>
            </div>

            <div
              *ngFor="let indicatorDetail of reportData.componentContributionItems; let i = index"
            >
              <div [ngClass]="i == 0 ? '' : 'page-break'"></div>
              <div class="indicatorName">
                <span class="Titalcase">{{ indicatorDetail?.indicatorName }}</span
                >&nbsp; ({{ indicatorDetail?.indicatorUnitName }})
              </div>
              <div class="tableHeadingForLifecycleStage">
                <div class="uniqTableSeq content-name-subtitle">
                  Table #1: {{ indicatorDetail?.indicatorName }}
                  {{ reportResource.lblPackagingComponents | lowercase }} -
                  {{ reportData?.functionalUnitName | lowercase }}
                </div>
              </div>
              <div style="margin-bottom: 30px">
                <piqet-angular-report-bar-chart-component
                  [isIsoReport]="true"
                  [impactItems]="indicatorDetail?.impactItems"
                ></piqet-angular-report-bar-chart-component>
              </div>
              <p class="figureIdClass uniqFigureSeq content-name-subtitle">
                Figure #1: {{ indicatorDetail?.indicatorName }} ({{
                  indicatorDetail?.indicatorUnitName
                }}) {{ reportResource.lblComponents | lowercase }} -
                {{ reportData?.functionalUnitName | lowercase }}
              </p>
            </div>
          </div>

          <ng-container *ngIf="reportData?.packageAccountedProductId == 2">
            <div class="page-break"></div>
            <div
              *ngIf="reportData.isProductContent && !reportData.isExcludeProductImpacts"
              class="row table-div"
            >
              <div>
                <div class="row">
                  <div class="lblLifeCyclesStages" id="packagingIngredient">
                    {{ reportResource.lblIngredient }}
                  </div>
                </div>
              </div>
              <div
                *ngFor="
                  let indicatorDetail of reportData?.ingredientContributionItems;
                  let i = index
                "
              >
                <div [ngClass]="i == 0 ? '' : 'page-break'"></div>
                <div class="indicatorName">
                  <span class="Titalcase">{{ indicatorDetail?.indicatorName }}</span
                  >&nbsp; ({{ indicatorDetail?.indicatorUnitName }})
                </div>
                <div class="tableHeadingForLifecycleStage">
                  <div class="uniqTableSeq content-name-subtitle">
                    Table #1:
                    {{ indicatorDetail?.indicatorName }}
                    {{ reportResource.lblPackagingIngredient | lowercase }} -
                    {{ reportData?.functionalUnitName | lowercase }}
                  </div>
                </div>
                <div style="margin-bottom: 30px">
                  <piqet-angular-report-bar-chart-ingredient
                    [impactItems]="indicatorDetail?.impactItems"
                    [isIsoReport]="true"
                  ></piqet-angular-report-bar-chart-ingredient>
                </div>
                <p class="figureIdClass uniqFigureSeq content-name-subtitle">
                  Figure #1: {{ indicatorDetail?.indicatorName }} ({{
                    indicatorDetail?.indicatorUnitName
                  }}) {{ reportResource.lblIngredient | lowercase }} -
                  {{ reportData?.functionalUnitName | lowercase }}
                </p>
              </div>
            </div>
          </ng-container>
          <div *ngIf="reportData.isInterpretationRights">
            <div>
              <div>
                <div
                  *ngIf="
                    reportData.goalAndScope?.interpretation &&
                    reportData.goalAndScope.interpretation.trim() !== ''
                  "
                >
                  <div class="row sub-title-class space">
                    <div>
                      <div>Interpretation</div>
                    </div>
                  </div>
                  <div>
                    <p class="row space contentClass content-text">
                      {{ reportData.goalAndScope.interpretation }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ng-container *ngIf="reportData.additionalItems.toLowerCase()?.includes('2')">
            <div class="page-break"></div>
            <div class="row space">
              <div class="headingTitle" id="scenarioDetails">
                {{ reportResource.lblScenarioDetails }}
              </div>
            </div>
            <div *ngIf="reportData.scenarioDetailItemList.length > 0">
              <ng-container
                *ngFor="let impactItems of reportData?.scenarioDetailItemList; let k = index"
              >
                <piqet-angular-report-scenario-detail
                  [scenarioDataList]="reportData?.scenarioDetailItemList[k]"
                  [impactItems]="impactItems"
                  [isCheckISO]="true"
                  [processIncluded]="impactItems?.projectProcessList"
                ></piqet-angular-report-scenario-detail>
              </ng-container>
            </div>

            <ng-container *ngFor="let item of reportData.scenarioContributionItems; let k = index">
              <div class="page-break"></div>
              <div class="row table-div">
                <div class="row">
                  <div class="lblLifeCyclesStages" id="resultsScenario">
                    {{ reportResource.lblResultScenario }}
                  </div>
                </div>
                <div class="tableHeading">
                  <div>{{ item.scenarioName }} contribution analysis</div>
                </div>
              </div>
              <div class="chartSpace">
                <piqet-angular-report-detail-contribution-chart
                  [impactItems]="item.impactItems"
                  [isIsoReport]="true"
                  [index]="k"
                ></piqet-angular-report-detail-contribution-chart>
              </div>
              <p class="figureIdClass uniqFigureSeq content-name-subtitle">
                Figure #1: {{ reportResource.lblAllLifeCycle }} - {{ item.scenarioName }}
              </p>
            </ng-container>
          </ng-container>

          <div>
            <div
              class="contentMiniClass"
              id="sensitivityAnalysis"
              *ngIf="isHideSensitivityAnalysis"
            >
              <p class="content-name">Sensitivity analysis</p>
              <ng-container
                *ngIf="reportData?.sensitivityAnalysis?.length > 0; else noDataSensitivity"
              >
                <div class="content-text">
                  <ng-container
                    *ngIf="
                      reportData?.goalAndScope?.sensitivityAnalysisDescription?.trim();
                      else defaultSensitivityText
                    "
                  >
                    {{ reportData?.goalAndScope.sensitivityAnalysisDescription }} The following
                    sensitivity analyses were conducted:
                  </ng-container>

                  <ng-template #defaultSensitivityText>
                    Several scenarios were considered to shed light on how variations in input data
                    could affect the study results. The following sensitivity analyses were
                    conducted:
                  </ng-template>
                </div>
                <div *ngFor="let item of reportData?.sensitivityAnalysis">
                  <div class="contentMiniClass">
                    <p class="content-name-subtitle uniqTableSeq">
                      Table #1: Summary of sensitivity analysis
                    </p>
                    <div class="table-content my-2">
                      <table class="table">
                        <thead>
                          <tr>
                            <td>Variants</td>
                            <td>Short name</td>
                            <td>Long name</td>
                            <td>Scenario comment</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Reference</td>
                            <td>{{ item.variationDetail.shortName }}</td>
                            <td>{{ item.variationDetail.name }}</td>
                            <td>
                              {{
                                item.variationDetail.description == ''
                                  ? '–'
                                  : item.variationDetail.description
                              }}
                            </td>
                          </tr>
                          <ng-container
                            *ngFor="
                              let childItem of item.variationDetail?.childItems;
                              let i = index
                            "
                          >
                            <tr *ngIf="childItem.shortName && childItem.name">
                              <td>Variation {{ i + 1 }}</td>
                              <td>{{ childItem.shortName }}</td>
                              <td>{{ childItem.name }}</td>
                              <td>
                                {{ childItem.description == '' ? '–' : childItem.description }}
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="contentMiniClass">
                    <p class="content-name-subtitle uniqTableSeq">
                      Table #1: Sensitivity analysis results
                    </p>
                    <div class="table-content my-2">
                      <!-- <p class="content-text text-danger">DOne</p> -->
                      <table class="table">
                        <thead>
                          <tr>
                            <td></td>
                            <td
                              class="sensitivityAnalysis"
                              *ngFor="let childItem of item?.variationDetail?.childItems"
                            >
                              <ng-container *ngIf="childItem.name != '' && childItem.shortName"
                                >{{ childItem.name }} variation from
                                {{ item?.variationDetail?.name }}</ng-container
                              >
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            *ngFor="
                              let totalImpactItems of item?.sensitivityAnalysis;
                              let i = index
                            "
                          >
                            <td style="width: 30%">
                              {{ totalImpactItems.indicatorName }}
                              {{ totalImpactItems.indicatorUnitName }}
                            </td>
                            <ng-container
                              *ngFor="
                                let totalImpactItem of totalImpactItems?.totalImpactValues?.split(
                                  ';'
                                );
                                let j = index
                              "
                            >
                              <td
                                *ngIf="
                                  j < item?.variationDetail?.childItems?.length &&
                                  item.variationDetail?.childItems[j]?.name != ''
                                "
                              >
                                <span style="color: black">{{ totalImpactItem }}</span>
                              </td>
                            </ng-container>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="content-text">
                    These specific scenarios were designed to investigate the more uncertain and
                    biggest contributor to the {{ reportData?.baseScenarioName }}
                    environmental impacts.
                  </div>
                </div>
              </ng-container>

              <ng-template #noDataSensitivity>
                <div class="content-text">
                  {{ reportData?.organizationName }} did not include a sensitivity analysis in this
                  assessment.
                </div>
              </ng-template>
            </div>
          </div>

          <ng-container *ngIf="reportData?.packageAccountedProductId == 2">
            <ng-container
              *ngIf="reportData.isProductContent && !reportData.isExcludeProductImpacts"
              class="row table-div"
            >
              <div class="page-break"></div>
              <ng-container *ngIf="reportData.productContributionItems.length > 0">
                <div class="row space">
                  <div class="headingTitle" id="productDetailsId">
                    {{ reportResource.lblProductDetails }}
                  </div>
                </div>
                <div>
                  <piqet-angular-report-product-detail
                    [impactItems]="reportData?.productDetailItem"
                  ></piqet-angular-report-product-detail>
                </div>
                <div class="row space">
                  <div class="headingTitle" id="ingredientsource">
                    {{ reportResource.lblIngredientDataSource }}
                  </div>
                </div>
                <div>
                  <piqet-angular-report-ingredientdatasource-details
                    [impactItems]="reportData?.ingredientDetailItem"
                  ></piqet-angular-report-ingredientdatasource-details>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="reportData.additionalItems.toLowerCase()?.includes('5')">
            <div class="page-break"></div>
            <div class="row space">
              <div class="headingTitle" id="categoryDefination">
                {{ reportResource.lblCatergoriesDefinition }}
              </div>
            </div>
            <div style="margin-bottom: 30px; margin-left: 8px">
              <piqet-angular-report-categories-definition
                [isCheckISO]="true"
                [indicatorList]="reportData?.indicatorList"
              ></piqet-angular-report-categories-definition>
            </div>
          </ng-container>

          <ng-container *ngIf="reportData.additionalItems.toLowerCase()?.includes('3')">
            <div class="page-break"></div>
            <div class="row space">
              <div class="headingTitle" id="dataSourceAtt">{{ reportResource.lblDataSource }}</div>
            </div>

            <div *ngFor="let item of reportData.dataSourceDetailItemList">
              <piqet-angular-report-data-source-etails
                [impactItems]="item"
              ></piqet-angular-report-data-source-etails>
            </div>
          </ng-container>
          <div *ngIf="reportData.isInterpretationRights">
            <div
              *ngIf="
                (reportData.goalAndScope?.otherAssumptions &&
                  reportData.goalAndScope.otherAssumptions.trim() !== '') ||
                (reportData.goalAndScope?.recommendationsAndConclusions &&
                  reportData.goalAndScope.recommendationsAndConclusions.trim() !== '')
              "
            >
              <div class="page-break"></div>

              <!-- Conclusion Title -->
              <div class="row space" id="scenarioComparison">
                <div class="headingTitle setFontWeight">Conclusion</div>
              </div>

              <!-- Other Assumptions / Limitations -->
              <div
                *ngIf="
                  reportData.goalAndScope?.otherAssumptions &&
                  reportData.goalAndScope.otherAssumptions.trim() !== ''
                "
              >
                <div class="row sub-title-class space">
                  <div>
                    <div>Other Assumptions / Limitations</div>
                  </div>
                </div>
                <div>
                  <p class="row space contentClass content-text">
                    {{ reportData.goalAndScope.otherAssumptions }}
                  </p>
                </div>
              </div>

              <!-- Recommendations And Conclusions -->
              <div
                *ngIf="
                  reportData.goalAndScope?.recommendationsAndConclusions &&
                  reportData.goalAndScope.recommendationsAndConclusions.trim() !== ''
                "
              >
                <div class="row sub-title-class space">
                  <div>
                    <div>Recommendations And Conclusions</div>
                  </div>
                </div>
                <div>
                  <p class="row space contentClass content-text">
                    {{ reportData.goalAndScope.recommendationsAndConclusions }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
